import { getTickPositions, getChartDateFormat, getXAxisTitleText, socOfYaxisIsVisible, getValueOfToolTip, } from '../chartFunctions';
export function getBatteryOptions(tabname, locale, data, t) {
    return {
        chart: {
            type: 'column',
            height: 480,
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'top',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                fontWeight: 'regular',
            },
        },
        yAxis: [
            {
                offset: 20,
                labels: {
                    style: {
                        color: '#434348',
                    },
                    formatter() {
                        return `${this.value}k`;
                    },
                },
                title: {
                    text: `${t('common.energy')}(Wh)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                min: 0,
                tickAmount: 6,
                opposite: true,
            },
            {
                visible: socOfYaxisIsVisible(tabname),
                labels: {
                    style: {
                        color: '#434348',
                    },
                },
                title: {
                    text: `${t('device.soc')}(%)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                min: 0,
                max: 100,
                tickAmount: 6,
                gridLineWidth: 0,
                opposite: true,
            },
        ],
        xAxis: [
            {
                title: {
                    text: getXAxisTitleText(tabname, t),
                    align: 'high',
                },
                labels: {
                    autoRotation: [0],
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
                tickPositions: getTickPositions(tabname, data.charge.map((item) => item.x)),
            },
        ],
        tooltip: {
            shared: true,
            formatter() {
                return getValueOfToolTip(tabname, this, locale, t);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                grouping: true,
            },
        },
        series: getBatterySeries(tabname, data, t),
        scrollbar: {
            enabled: true,
        },
        navigator: {
            xAxis: {
                labels: {
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
            },
        },
        noData: {
            position: {},
            attr: {},
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#202030',
            },
        },
    };
}
export function getBatterySeries(tabname, data, t) {
    let series = [];
    switch (tabname) {
        case 'hourly':
            series.push({
                yAxis: 1,
                type: 'line',
                name: t('device.soc'),
                color: '#9b5ba4',
                data: data.soc,
            });
            series = series.concat([
                {
                    type: 'column',
                    yAxis: 0,
                    name: t('device.charged'),
                    color: '#89cd1d',
                    data: data.charge,
                },
                {
                    type: 'column',
                    name: t('device.discharged'),
                    color: '#2b53a4',
                    data: data.discharge,
                },
            ]);
            return series;
        default:
            return [
                {
                    type: 'column',
                    yAxis: 0,
                    name: t('device.charged'),
                    color: '#89cd1d',
                    data: data.charge,
                },
                {
                    type: 'column',
                    name: t('device.discharged'),
                    color: '#2b53a4',
                    data: data.discharge,
                },
            ];
    }
}
